import { Component, Input } from '@angular/core';
import { PhysicianAccountPgpsDTO } from '@mynexus/mynexus-ui-lib';

@Component({
    selector: 'app-physician-verification',
    templateUrl: './physician-verification.component.html',
    styleUrls: ['./physician-verification.component.scss'],
    standalone: false
})
export class PhysicianVerificationComponent {
  physicianCombineData: any;

  @Input() set physician(value: PhysicianAccountPgpsDTO) {
    const { physicianAccountDTO, physicianPgpDTOList } = value;

    this.physicianDate = value;
    this.physicianCombineData = {...physicianAccountDTO, ...physicianPgpDTOList[0]};
   }

  get physician(): PhysicianAccountPgpsDTO {
    return this.physicianDate;
  }

  @Input() isExternalUser = false;

  private physicianDate: PhysicianAccountPgpsDTO;
}
